import { CrudCollectionPage, type CrudRecord } from "./CrudCollectionPage";
import { hasPermission } from "../core/session";

export function EvidencePage() {
  return (
    <CrudCollectionPage
      label="Evidence"
      singular="Evidence"
      endpoint="/evidence"
      icon="steps"
      canUpdate={hasPermission("evidence.update")}
      createDefaults={{
        type: "Photo",
        identifier: "",
        description: "",
        cid: null,
      }}
      fields={[
        { key: "description", label: "Title" },
        { key: "type", label: "Type" },
        { key: "identifier", label: "Identifier" },
        { key: "cid", label: "CID", type: "number" },
      ]}
      advancedFields={[
        { key: "type", label: "Category" },
        { key: "identifier", label: "Identifier" },
        { key: "cid", label: "State ID", type: "number" },
        { key: "createdFrom", label: "Date From", type: "datetime-local" },
        { key: "createdTo", label: "Date To", type: "datetime-local" },
      ]}
      itemTitle={(item) => value(item.identifier) || "Unidentified evidence"}
      itemDescription={(item) => value(item.description)}
      prepareWrite={(item) => ({
        type: value(item.type),
        identifier: value(item.identifier),
        description: value(item.description),
        cid: nullableNumber(item.cid),
      })}
      renderAfterFields={(item) => (
        <>
          {isImageUrl(item.identifier) ? (
            <div class="p-7">
              <img
                class="max-h-[28rem] max-w-full object-contain"
                src={value(item.identifier)}
                alt="Evidence"
              />
            </div>
          ) : null}
          <AttachedRecords item={item} />
        </>
      )}
    />
  );
}

function AttachedRecords(props: { item: CrudRecord }) {
  const attached = Array.isArray(props.item.attached)
    ? (props.item.attached as CrudRecord[])
    : [];
  return (
    <section class="bg-[rgba(255,255,255,.04)] p-3">
      <p class="mb-2 text-sm text-white-55">Used in reports</p>
      <div class="flex flex-col gap-2">
        {attached.length === 0 ? (
          <p class="text-sm text-white-35">No linked report, incident or docket.</p>
        ) : (
          attached.map((record) => (
            <div class="item-list-bg bg-gray-gradient px-3 py-2">
              <p>{`${value(record.type)}: ${value(record.title)}`}</p>
              <p class="text-xs text-white-55">ID: {value(record.id)}</p>
            </div>
          ))
        )}
      </div>
    </section>
  );
}

function value(input: unknown): string {
  return typeof input === "string" || typeof input === "number"
    ? String(input)
    : "";
}

function nullableNumber(input: unknown): number | null {
  const number = Number(input);
  return Number.isSafeInteger(number) && number > 0 ? number : null;
}

function isImageUrl(input: unknown): boolean {
  if (typeof input !== "string") return false;
  try {
    const url = new URL(input);
    return /\.(jpeg|jpg|gif|png|webp)$/i.test(url.pathname);
  } catch {
    return false;
  }
}
